import { render, staticRenderFns } from "./TarjetaCurso.vue?vue&type=template&id=033b59a7&scoped=true&"
import script from "./TarjetaCurso.vue?vue&type=script&lang=js&"
export * from "./TarjetaCurso.vue?vue&type=script&lang=js&"
import style0 from "./TarjetaCurso.vue?vue&type=style&index=0&id=033b59a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033b59a7",
  null
  
)

export default component.exports